import { render } from "./IconVaccine.vue?vue&type=template&id=1f72f1b6"
import script from "./IconVaccine.vue?vue&type=script&lang=ts"
export * from "./IconVaccine.vue?vue&type=script&lang=ts"
script.render = render

export default script